import { Component, OnInit } from "@angular/core";
import { TechnicianStockLevelsGridComponent } from "../technician-stock-levels/technician-stock-levels-grid.component";
import { APTechnicianHash } from "../../_models/technician.interface";
import { UserService } from "../../_services";
import { TechnicianStockLevelService } from "../../_services/technician-stock-level.service";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { faArrowLeft, faEdit, faIndustry, faKey, faPhone, faStore, faTrash, faUser } from "@fortawesome/free-solid-svg-icons";
import { faSignIn } from "@fortawesome/pro-solid-svg-icons";
import { faProductHunt } from "@fortawesome/free-brands-svg-icons";

import { NgxMapboxGLModule } from "ngx-mapbox-gl";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { FaIconComponent, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { RecordNavigationComponent } from "../_shared/record-navigation/record-navigation.component";
import { UserPasskeysComponent } from "./user-passkeys/user-passkeys.component";
export type UserShowTab = "warehouses" | "projects" | "employees" | "stock";
@Component({
  selector: "hawk-user-show",
  templateUrl: "./user-show.component.html",
  styleUrls: ["./user-show.component.scss"],
  standalone: true,
  imports: [
    RecordNavigationComponent,
    FaIconComponent,
    NgxMapboxGLModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    MatSlideToggleModule,
    FontAwesomeModule,
    RouterLink,
    UserPasskeysComponent,
    TechnicianStockLevelsGridComponent,
  ],
  host: {
    class: "app-page",
  },
})
export class UserShowComponent implements OnInit {
  protected tabId = "warehouses";

  /**
   * Anzahl der Bestandszeilen für die Reiterbeschriftung. Wird vorab geladen,
   * weil das Grid erst beim Öffnen des Reiters gerendert wird — sonst stünde
   * dort so lange eine 0.
   */
  protected stockLevelCount = 0;

  /** Nur Techniker führen eigenes Material — für alle anderen entfällt der Reiter. */
  protected get hasTechnicianRole(): boolean {
    return this.user?.roles?.some(role => role.name === "TECHNICIAN") ?? false;
  }
  protected readonly faUser = faUser;

  user: APTechnicianHash;
  ctrlIsPressed: boolean = false;

  showOnlyActiveProjects: boolean = true;
  userIsDeletable: boolean = false;

  constructor(
    public userService: UserService,
    private stockLevelService: TechnicianStockLevelService,
    public route: ActivatedRoute,
    private router: Router,
  ) {
    document.body.onkeydown = (event) => {
      if (event.ctrlKey) this.ctrlIsPressed = event.ctrlKey;
    };
    document.body.onkeyup = (event) => {
      if (!event.ctrlKey) this.ctrlIsPressed = event.ctrlKey;
    };
  }

  ngOnInit(): void {
    const id = Number.parseInt(this.route.snapshot.paramMap.get("id"));
    this.userService.getAPUser(id).subscribe(
      (user) => {
        this.user = user;
      },
      (err) => {
        console.log(err);
      },
    );

    void this.stockLevelService.list({ userId: id })
      .then((levels) => { this.stockLevelCount = levels.length; })
      .catch(() => { this.stockLevelCount = 0; });

    this.userService.userIsDeletable(id).subscribe(
      (data) => {
        this.userIsDeletable = data.deletable;
      },
      (err) => {
        console.log(err);
      },
    );
  }

  toggleUserActivation() {
    this.setUserActivation(!this.user.active);
  }

  setUserActivation(active: boolean): void {
    this.userService.updateUser(this.user.id, { active }).subscribe(
      (user) => {
        this.user = user;
      },
      (err) => {
        console.log(err);
      },
    );
  }

  deleteUser(): void {
    this.userService.deleteUser(this.user.id).subscribe(
      (_) => {
        this.router.navigate(["/benutzer"]);
      },
      (err) => {
        console.log(err);
      },
    );
  }

  hasActiveAppConfig(): boolean {
    if (!this.user?.app_config) return false;
    return Object.values(this.user.app_config).some((v) => v === true);
  }

  protected readonly faProductHunt = faProductHunt;
  protected readonly faPhone = faPhone;
  protected readonly faEdit = faEdit;
  protected readonly faKey = faKey;
  protected readonly faArrowLeft = faArrowLeft;
  protected readonly faSignIn = faSignIn;
  protected readonly faTrash = faTrash;
  protected readonly faIndustry = faIndustry;
  protected readonly faStore = faStore;
}
